import { render, staticRenderFns } from "./PosiTions.vue?vue&type=template&id=bd6056a2"
import script from "./PosiTions.vue?vue&type=script&lang=js"
export * from "./PosiTions.vue?vue&type=script&lang=js"
import style0 from "./PosiTions.vue?vue&type=style&index=0&id=bd6056a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports